import whatsApp from '../../../assets/images/whatsApp.png';

export const WhatsAppIcon = ({ size = 14 }) => {
  return (
    <div
      className="relative flex justify-center items-center"
      style={{ width: size, height: size }}
    >
      <img
        src={whatsApp}
        alt="whatsApp"
        className="absolute w-full h-full object-contain object-center"
        style={{ filter: 'invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(90%) contrast(119%)' }}
      />
    </div>
  );
};
